import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { messages } from 'constantes';
import { withApi, withNotification } from 'wrappers';
import OnlineIndicator from '../OnlineIndicator';

const CheckboxInput = (props) => {
  const {
    doPut,
    appError,
    appInfo,
    id,
    url,
    isChecked,
    forwardedRef,
    disabledCheckView,
    onChange,
    label,
  } = props;
  const [isCheck, setIsCheck] = useState(!!isChecked);

  const onChangeField = async () => {
    setIsCheck(!isCheck);

    const params = {
      url,
      data: { id, value: !isCheck },
    };

    try {
      await doPut(params);
      forwardedRef.current.refresh();
      appInfo(messages.crud.update);
    } catch (error) {
      appError(messages.crud.fail, error);
    }
  };

  return (
    label ? (
      <>
        <FormControlLabel
          control={(
            <Checkbox
              key={id}
              disabled={disabledCheckView}
              checked={isCheck}
              onChange={() => (onChange ? onChange(setIsCheck, isCheck, id) : onChangeField())}
            />
          )}
          label={label}
        />
      </>
    ) : (
      <Checkbox
        key={id}
        disabled={disabledCheckView}
        checked={isCheck}
        onChange={() => (onChange ? onChange(setIsCheck, isCheck, id) : onChangeField())}
        label={label}
      />
    )
  );
};

OnlineIndicator.defaultProps = {
  isChecked: false,
};

CheckboxInput.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  doPut: PropTypes.func,
  label: PropTypes.string,
  onChange: PropTypes.func,
  url: PropTypes.string.isRequired,
  disabledCheckView: PropTypes.bool,
  appInfo: PropTypes.func.isRequired,
  appError: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  forwardedRef: PropTypes.oneOfType([PropTypes.object]),
};

// export default CheckboxInput;
export default withApi(withNotification(CheckboxInput));
